import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CapitalIncreaseHomeResolver} from '../core/resolver/capital-increase-home-resolver';
import {CapitalIncreaseComponent} from './capital-increase.component';
import {HomeComponent} from './home/home.component';
import {CapitalIncreaseDetailResolver} from '../core/resolver/capital-increase-detail-resolver';
import {DetailComponent} from "./detail/detail.component";
import { DedicatedComponent } from './dedicated/dedicated.component';
import { MercenaryComponent } from './mercenary/mercenary.component';
import { FreeComponent } from './free/free.component';
import { CapitalIncreaseDedicatedResolver } from '../core/resolver/capital-increase-dedicated-resolver';
import { CapitalIncreaseFreeResolver } from '../core/resolver/capital-increase-free-resolver';
import { CapitalIncreaseMercenaryResolver } from '../core/resolver/capital-increase-mercenary-resolver';
import { YearComponent } from './year/year.component';
import { CapitalIncreaseYearResolver } from '../core/resolver/capital-increase-year-resolver';

const routes: Routes = [
  {
    path: '', component: CapitalIncreaseComponent,
    children: [
      { path: 'dedicated',data: { revalidate: 30 },resolve: { capitalIncreaseDedicatedResolver: CapitalIncreaseDedicatedResolver}, component: DedicatedComponent},
      { path: 'free',data: { revalidate: 30 },resolve: { capitalIncreaseFreeResolver: CapitalIncreaseFreeResolver}, component: FreeComponent},
      { path: 'mercenary',data: { revalidate: 30 },resolve: { capitalIncreaseMercenaryResolver: CapitalIncreaseMercenaryResolver}, component: MercenaryComponent},
      { path: 'year/:year/:month',data: { revalidate: 30 },resolve: { capitalIncreaseYearResolver: CapitalIncreaseYearResolver  }, component: YearComponent},
      { path: 'year/:year',data: { revalidate: 30 },resolve: { capitalIncreaseYearResolver: CapitalIncreaseYearResolver  }, component: YearComponent},
      { path: ':url',data: { revalidate: 30 },resolve: { capitalIncreaseDetailResolver: CapitalIncreaseDetailResolver}, component: DetailComponent},
      { path: '', resolve: {capitalIncreaseHomeResolver: CapitalIncreaseHomeResolver}, component: HomeComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CapitalIncreaseRoutingModule {
}
